var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('main',{staticClass:"page-body"},[_c('router-view')],1),_c('Footer',{staticClass:"page-footer mt-5",class:_vm.isTransparent ? 'bg-none' : 'bg-white shadow'})],1)}
var staticRenderFns = []

export { render, staticRenderFns }